import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { reorderTask } from 'api/task.service';
import { useToast } from 'hooks/ui';
import { taskKeys } from './tasks';

type MutationFnArgs = {
  id: string;
  order: string;
};

export const useTaskReorderQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: ({ id, order }: MutationFnArgs) => reorderTask(id, order),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      toast.success('Task has been edited successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
